import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Stepper } from '../../common/TailwindComponents';
export var EnrollmentStepperWrapper = function EnrollmentStepperWrapper(_ref) {
  var step = _ref.step,
    goToStep = _ref.goToStep;
  var _useState = useState([{
      id: '01',
      name: 'Review client details',
      onClick: function onClick() {
        return goToStep(0);
      },
      status: 'upcoming'
    }, {
      id: '02',
      name: 'Enrollment application',
      onClick: function onClick() {
        return goToStep(1);
      },
      status: 'upcoming'
    }, {
      id: '03',
      name: 'Review request',
      status: 'upcoming'
    }]),
    _useState2 = _slicedToArray(_useState, 2),
    steps = _useState2[0],
    setSteps = _useState2[1];
  useEffect(function () {
    var newSteps = _mapInstanceProperty(steps).call(steps, function (s, index) {
      var status = 'upcoming';
      if (index === step) {
        status = 'current';
      }
      if (index < step) {
        status = 'complete';
      }
      return _objectSpread(_objectSpread({}, s), {}, {
        status: status
      });
    });
    setSteps(newSteps);
  }, [step]);
  return /*#__PURE__*/React.createElement(Stepper, {
    steps: steps
  });
};
EnrollmentStepperWrapper.propTypes = {
  step: PropTypes.number.isRequired,
  goToStep: PropTypes.func.isRequired
};
//# sourceMappingURL=EnrollmentStepperWrapper.js.map